<div class="card" rte="ie">
    <div class="flex align-items-center" [style.margin-bottom.rem]="1.5">
        <h1 rte="if" [style.margin]="0">Menu Designer</h1>
        <p-button label="Manage Saved Menu Items" icon="pi pi-database" size="small" routerLink="./database-items" styleClass="ml-2" />
    </div>
    <div class="main-menu" rte="ih">
        <main-menu-designer rte="1bj"></main-menu-designer>
    </div>
    <div class="footer-menu" rte="j2">
        <p-fieldset legend="Footer Menu" rte="1bm">
            <footer-menu-designer rte="1bk"></footer-menu-designer>
        </p-fieldset>
    </div>
</div>
